import React from 'react';
import './Footer.css';

const Footer = () => (
  <div className="footer section__padding">
    <div className="footer-links">

      <div className="footer-links_div">
        <h4>Customer Care</h4>
        <p><a href="/shop-with-ease">Shop with Ease</a></p>
        <p><a href="/help-center">Help Center</a></p>
        <p><a href="/track-your-order">Track Your Order</a></p>
        <p><a href="/returns-and-exchanges">Returns & Exchanges</a></p>
        <p><a href="/start-a-return">Start a Return</a></p>
        <p><a href="/shipping">Shipping</a></p>
        <p><a href="/support/fitting-guide">Fit & Apparel Guides</a></p>
      </div>
      <div className="footer-links_div">
        <h4>Account</h4>
        <p><a href="https://auth.alexmenswear.com/settings">Manage Your Alex Menswear Account</a></p>
        <p><a href="https://auth.alexmenswear.com/concierge">Request Services and Concierge</a></p>
        <p><a href="https://auth.alexmenswear.com/sign-up">Create an Alex Menswear Account</a></p>
      </div> 

      <div className="footer-links_div">
        <h4>About Alex Menswear</h4>
        <p><a href={"/our-story"}>Our Heritage</a></p>
        <p><a href={"/sitemap"}>Site Map</a></p>
        <p><a href={"/contact"}>Contact Us</a></p>
      </div>

      <div className="footer-links_div">
        <h4>Get In Touch</h4>
        <p><a href={"mailto:solutions@etheware.com"}>Email Alex Menswear</a></p>
        <p>Our Client Advisors are available to assist you by phone at +1.866.ALEXMENSWEAR , or you may also chat with us by email.</p>
        <h6>United States</h6>
      </div>
    </div>
    <div className="footer-copyright">
      <p>@2026 AlexMenswear.com. All rights reserved.</p>
    </div>
    <div className="footer__buttons">
      <p><a href="/legal">Privacy Policy</a></p>
      <div className="icon__div"/>
      <p><a href="/legal">Terms of Use</a></p>
      <div className="icon__div"/>
      <p><a href="/legal">Sales and Refunds</a></p>
      <div className="icon__div"/>
      <p><a href="/legal">Legal</a></p>
      <div className="icon__div"/>
      <p><a href="/sitemap">Site Map</a></p>
    </div>
      
      <div className="footer-links_logo">
        <p>Copyright © 2026 Alex Menswear<br /> All Rights Reserved.</p>
    </div>
  </div>
);

export default Footer;